module.exports = __webpack_public_path__ + "static/media/RecMat-formcDeProf-med.ae9b8c95.png";